import { render, staticRenderFns } from "./request-features.vue?vue&type=template&id=3d99ad07"
import script from "./request-features.vue?vue&type=script&lang=js"
export * from "./request-features.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports